import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const DealBreakersDialog = ({ open, close }) => {
  const handleRedirect = () => {
    window.location.href = "https://dealbreakers.show";
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Redirecting to DealBreakers
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          DealBreakers check-in is hosted on our DealBreakers site. Click below to
          continue and log in with the same email and password you normally use.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button onClick={handleRedirect} autoFocus>
          Go to DealBreakers
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DealBreakersDialog;